import type { ReactNode } from 'react';
import type { AuthAction } from '@/types/gql.generated';

export type AuthLocationState = {
  state:
    | undefined
    | {
        /** The path a user tried to access before being redirected to login */
        from?: Location;
        /** The user's email when switching between login and register */
        email?: string;
      };
};

export type AuthResult = 'login' | 'register';

/**
 * The post-verification name prompt. Deliberately not an `AuthAction`: the server
 * never asks for a name, and it cannot - knowing whether to ask requires knowing
 * the account is new, which is only safe to reveal after a code has been proven.
 */
export const AUTH_NAME_STEP = 'COLLECT_NAME';

/** What the auth panel is currently showing. */
export type AuthPanelStep = AuthAction | typeof AUTH_NAME_STEP | null;

/** Every field the auth panel's single form carries across all of its steps. */
export type AuthFormValues = {
  email: string;
  name: string;
  password: string;
  code: string;
};

export type AuthHeaderRenderProp = ({
  authAction,
  email,
}: {
  authAction: AuthAction | null;
  email?: string;
}) => ReactNode;
